export namespace AsideAction {
    export class Open {
        static readonly type = 'AsideAction.Open';

        constructor(public component: any) {
        }
    }
}

